var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "18px",
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "23979DC4-A7E4-489C-88E7-37869341D308") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-provider-profile-2",
    transform: "translate(-687.000000, -212.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(688.000000, 213.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "currentColor",
    strokeWidth: 2,
    x: 0,
    y: 3,
    width: 17,
    height: 13,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "currentColor",
    fillRule: "nonzero",
    x: 0,
    y: 6.5,
    width: 17,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 3.25,
    y: 0.25,
    width: 3,
    height: 4.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 10.75,
    y: 0.25,
    width: 3,
    height: 4.5,
    rx: 1.5
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c018467cb06b4b7d337da4126546a980.svg";
export { ForwardRef as ReactComponent };